import { useSelector } from "react-redux";
import { useRef, useEffect } from "react";
import PropTypes from "prop-types";
import SoftBox from "components/SoftBox";
import { TimelineProvider } from "../context";
import { COMPONENT_PROPS_TAB_PREFIX } from "constants/flowDesigner";

function TimelineList({ dark = false, children }) {
  const { activeFlexLayoutTab } = useSelector((store) => store?.designer?.tabs);
  const timelineRef = useRef(null);

  useEffect(() => {
    if (timelineRef?.current && activeFlexLayoutTab?.includes(COMPONENT_PROPS_TAB_PREFIX)) {
      const parentNode = timelineRef.current.parentNode;
      const nodes = timelineRef.current.querySelectorAll(
        `.timeline-log-${activeFlexLayoutTab.replace(COMPONENT_PROPS_TAB_PREFIX, "")}`
      );

      if (nodes.length) {
        const selectedNode = nodes[nodes.length - 1];

        selectedNode?.scrollIntoView({
          behavior: "smooth",
          block: "start"
        });

        return;
      }

      parentNode.scrollTo({
        top: parentNode.scrollHeight,
        behavior: "smooth"
      });
    }
  }, [children, activeFlexLayoutTab]);

  return (
    <TimelineProvider value={dark}>
      <SoftBox
        ref={timelineRef}
        bgColor={dark ? "dark" : "white"}
        variant="gradient"
        className="timeline-list"
        sx={{ height: "100%" }}
      >
        <SoftBox sx={{ height: "100%" }} paddingLeft={2}>
          {children}
        </SoftBox>
      </SoftBox>
    </TimelineProvider>
  );
}

// Typechecking props for the TimelineList
TimelineList.propTypes = {
  title: PropTypes.string.isRequired,
  dark: PropTypes.bool,
  children: PropTypes.node.isRequired
};

export default TimelineList;
